/* eslint-disable react/no-array-index-key */
import {
  Button,
  Hidden,

  //   IconButton,
  Stack,
  Typography
} from '@mui/material';

import React, { useEffect, useState } from 'react';
import i18n from '@utils/i18n';
import Link from '@components/LocalizedLink';
import RowLayout from '@components/RowLayout';

import MediaService from '@services/media';
import { Formatter } from '@utils/formatter';
// import env from '@constants/env';

const NewsItem = ({ item, hasIcon = true, index, isMobile = false }) => {
  if (isMobile) {
    return (
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          gap: { md: 1, xs: 1 },
          alignItems: 'center',
          justifyContent: { md: 'center', xs: 'center' }
        }}
      >
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            gap: { md: 1, xs: 1 },

            justifyContent: { md: 'center', xs: 'center' }
          }}
        >
          <Typography
            sx={{
              fontSize: { md: 18, sm: 18, xs: 14 },
              fontWeight: 500,
              letterSpacing: { xs: '-0.42px', sm: '-0.9px', md: '-0.9px' },
              whiteSpace: 'pre-line',
              wordBreak: 'keep-all', // Prevent breaking words
              overflowWrap: 'break-word', // Handle long word,
              color: { xs: '#000' },
              minHeight: { sm: '40px' }
            }}
            fontFamily="Pretendard"
            textAlign={{ md: 'left' }}
          >
            {item?.title}
          </Typography>
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: 1,
              alignItems: 'center',
              justifyContent: 'flex-start'
            }}
          >
            <Typography
              sx={{
                fontSize: { md: 14, xs: 14 },
                fontWeight: 500,
                fontFamily: 'Pretendard',
                whiteSpace: 'nowrap',
                letterSpacing: '-0.7px',
                color: { md: '#7E7F88', xs: '#244EE2' }
              }}
              fontFamily="Pretendard"
            >
              {item?.publisher}
            </Typography>
            <Typography
              sx={{
                fontSize: { md: 18, xs: 14 },
                fontWeight: { md: 500, xs: 500 },
                whiteSpace: 'nowrap',
                fontFamily: 'Pretendard',
                lineHeight: '100%',
                color: { xs: '#B8B8B8' },
                letterSpacing: '-0.7px'
              }}
            >
              {item?.publishedDate
                ? Formatter.formatTime(item?.publishedDate, 'YYYY.MM.DD')
                : ''}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    );
  }
  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%',
        gap: { md: 1, xs: 1 },
        alignItems: 'center',
        justifyContent: { md: 'center', xs: 'center' }
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
          alignItems: 'center',
          justifyContent: 'flex-start',
          minWidth: 123
        }}
      >
        <Typography
          sx={{
            fontSize: { md: 18, xs: 12 },
            fontWeight: 500,
            fontFamily: 'Pretendard',
            whiteSpace: 'nowrap',
            letterSpacing: '-0.9px',
            lineHeight: '100%',
            color: { md: '#244EE2', xs: '#B8B8B8' }
          }}
          fontFamily="Pretendard"
        >
          {item?.publisher}
        </Typography>
      </Stack>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
          gap: { md: 1, xs: 1 },

          justifyContent: { md: 'center', xs: 'center' }
        }}
      >
        <Typography
          sx={{
            fontSize: { md: 18, xs: 14 },
            fontWeight: 500,
            letterSpacing: { xs: '-0.42px', md: '-0.9px' },
            whiteSpace: 'pre-line',
            wordBreak: 'keep-all', // Prevent breaking words
            overflowWrap: 'break-word', // Handle long word,
            color: { xs: '#000' }
          }}
          fontFamily="Pretendard"
          textAlign={{ md: 'left' }}
        >
          {item?.title}
        </Typography>
        {/* <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 1,
            alignItems: 'center',
            justifyContent: 'flex-start'
          }}
        >
          <Typography
            sx={{
              fontSize: { md: 14, xs: 12 },
              fontWeight: 500,
              fontFamily: 'Pretendard',
              whiteSpace: 'nowrap',
              color: { md: '#7E7F88', xs: '#B8B8B8' }
            }}
            fontFamily="Pretendard"
          >
            {item?.publisher}
          </Typography>
          {item?.publisher && item?.publishedDate && (
            <Stack sx={{ height: '12px' }}>
              <Divider
                flexItem
                sx={{
                  borderColor: { md: '#D3D5DF', xs: '#B8B8B8' },
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '12px'
                }}
                orientation="vertical"
              />
            </Stack>
          )}
        </Stack> */}
      </Stack>

      <Stack
        sx={{
          width: 120, // or whatever width fits your design
          alignItems: 'flex-end'
        }}
      >
        <Typography
          sx={{
            fontSize: { md: 18, xs: 12 },
            fontWeight: 500,
            whiteSpace: 'nowrap',
            flexGrow: 1,
            fontFamily: 'Pretendard',

            lineHeight: '100%',
            color: { xs: '#B8B8B8' },
            fontVariantNumeric: 'tabular-nums'
          }}
        >
          {item?.publishedDate
            ? Formatter.formatTime(item?.publishedDate, 'YYYY.MM.DD')
            : ''}
        </Typography>
      </Stack>
      {/* {hasIcon && (
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: 142,
            gap: { md: 1, xs: 1 },
            height: { md: 80, xs: 180 },
            justifyContent: { md: 'flex-start', xs: 'center' }
          }}
        >
          <img
            src={
              item?.thumbnail
                ? `${env.s3BaseUrl}/${item?.thumbnail}`
                : '/illustrations/default_media.png'
            }
            style={{
              height: '100%',
              objectFit: 'cover',
              width: '100%'
            }}
            alt="thumbnail"
          />
        </Stack>
      )} */}
    </Stack>
  );
};

const isEnglish = () => {
  const lang = localStorage.getItem('i18nextLng')?.toLowerCase() === 'en';
  return lang;
};
const News = () => {
  const t = i18n.getFixedT(null, null, '');

  const [newsList, setNewsList] = useState([]);
  const getLatestNews = async () => {
    const rs = await MediaService.getMainMediaList();
    if (rs?.error) {
      console.log(rs.error);
    } else {
      setNewsList(rs?.data);
    }
  };
  useEffect(() => {
    getLatestNews();
  }, []);
  return (
    <RowLayout
      sx={{
        height: 'auto',
        backgroundColor: '#FFFFFF',
        alignItems: 'center',
        justifyContent: 'center',
        py: { md: '120px', xs: '60px', sm: '140px' }
      }}
    >
      <Hidden mdDown>
        <Stack
          sx={{
            width: { md: '75%', lg: '100%' },
            height: '100%',
            maxWidth: '1920px',
            px: { lg: '320px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10
          }}
        >
          <Stack
            textAlign="left"
            gap={3}
            sx={{ width: '100%' }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="100"
            data-aos-duration="300"
            data-aos-once="true"
          >
            <Typography
              variant="sectionChip"
              sx={{
                fontSize: '32px',
                fontFamily: 'Swear Display',
                fontWeight: 500,
                fontStyle: 'italic',
                lineHeight: '100%',
                letterSpacing: '-1.6px'
              }}
            >
              News
            </Typography>
            <Stack sx={{ gap: 5 }}>
              <Typography
                fontWeight={700}
                fontFamily="Pretendard"
                sx={{
                  color: '#000',
                  fontSize: 48,
                  letterSpacing: '-2.4px',
                  lineHeight: '100%'
                }}
              >
                {t('pages.flagshop.news.title')}
              </Typography>
              <Typography
                fontWeight={500}
                fontFamily="Pretendard"
                sx={{
                  color: '#000',
                  fontSize: 18,
                  letterSpacing: '-0.9px',
                  lineHeight: '100%',
                  whiteSpace: !isEnglish() ? 'nowrap' : 'pre-line'
                }}
              >
                {t('pages.flagshop.news.subtitle')}
              </Typography>
            </Stack>
          </Stack>
          <Stack
            sx={{
              height: '100%',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            data-aos="fade-up"
            data-aos-offset="0"
            data-aos-delay="300"
            data-aos-duration="0"
          >
            {newsList?.map((item, index) => (
              <Stack
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  p: '40px 0px !important',
                  // height: '92px',
                  width: '100%',
                  borderTop: index === 0 ? '1px solid #E3E3E3' : 0,
                  borderBottom: '1px solid #E3E3E3',
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}
                component={Link}
                href={item?.url}
                target="_blank"
                key={`${index}-${item?.url}`}
              >
                {' '}
                <NewsItem item={item} />{' '}
              </Stack>
            ))}
          </Stack>
          <Stack mt="20px" width="100%" sx={{ alignItems: 'center' }}>
            <Link
              href="/media"
              underline="none"
              color="inherit"
              component="a"
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none'
              }}
              aria-label="Navigate to media"
            >
              <Button
                variant="outlined"
                disableRipple
                sx={{
                  color: '#244EE2',
                  backgroundColor: '#FFFFFF',
                  minWidth: '130px',
                  width: 'auto',
                  p: '10px 12px 10px 16px',
                  fontSize: 16,
                  fontWeight: 500,
                  borderRadius: 0,
                  boxShadow: 0,
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #244EE2 !important',
                  gap: 1,
                  height: 40,
                  ':hover': {
                    color: '#244EE2',
                    backgroundColor: '#FFF'
                  }
                }}
              >
                {t('button.see-more-2')}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  style={{ marginTop: '-2px' }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 7V12H7V7H12V5H7V0H5V5H0V7H5Z"
                    fill="#244EE2"
                  />
                </svg>
              </Button>
            </Link>
          </Stack>
        </Stack>{' '}
      </Hidden>
      <Hidden mdUp>
        <Stack
          sx={{
            width: { xs: '100%' },
            height: '100%',

            px: { xs: '20px', sm: '40px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2.5
          }}
        >
          <Stack textAlign="left" width="100%" gap="10px">
            <Typography
              variant="sectionChip"
              sx={{
                fontSize: '32px',
                fontFamily: 'Swear Display',
                fontWeight: 500,
                fontStyle: 'italic',
                lineHeight: '100%',
                letterSpacing: '-1.6px'
              }}
            >
              News
            </Typography>
            <Typography
              fontWeight={700}
              fontFamily="Pretendard"
              sx={{
                color: '#212121',
                fontSize: { xs: 30, sm: 40 },
                mt: '40px',
                letterSpacing: { xs: '-1.5px', sm: '-2.4px' },
                lineHeight: '130%'
              }}
            >
              {t('pages.flagshop.news.title-mobile')}
            </Typography>

            <Typography
              fontWeight={500}
              fontFamily="Pretendard"
              sx={{
                color: '#212121',
                fontSize: 18,
                mt: '40px',
                letterSpacing: '-0.9px',
                lineHeight: '130%'
              }}
            >
              {t('pages.flagshop.news.subtitle')}
            </Typography>
          </Stack>
          <Stack
            sx={{
              mt: { xs: 2.5, sm: '60px' },
              height: '100%',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {newsList?.map((item, index) => (
              <Stack
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  py: { xs: 2, sm: 2.5 },
                  height: 'auto',
                  width: '100%',
                  borderTop: index === 0 ? '1px solid #DEE2E6' : 0,
                  borderBottom: '1px solid #DEE2E6',
                  cursor: 'pointer',
                  textDecoration: 'none'
                }}
                component={Link}
                href={item?.url}
                target="_blank"
                key={`${index}-${item?.url}`}
              >
                {' '}
                <NewsItem item={item} hasIcon={false} isMobile />{' '}
              </Stack>
            ))}
          </Stack>
          <Stack mt="20px" width="100%" sx={{ alignItems: 'center' }}>
            <Link
              href="/media"
              underline="none"
              color="inherit"
              component="a"
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none'
              }}
              aria-label="Navigate to media"
            >
              <Button
                variant="outlined"
                disableRipple
                sx={{
                  color: '#244EE2',
                  backgroundColor: '#FFFFFF',
                  minWidth: '125px',
                  width: 'auto',

                  fontSize: 12,
                  fontWeight: 500,
                  borderRadius: 0,
                  boxShadow: 0,
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: '1px solid #244EE2 !important',
                  gap: 0.5,
                  height: 40,
                  ':hover': {
                    color: '#244EE2',
                    backgroundColor: '#FFF'
                  }
                }}
              >
                {t('button.see-more-2')}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  style={{ marginTop: '-2px' }}
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5 7V12H7V7H12V5H7V0H5V5H0V7H5Z"
                    fill="#244EE2"
                  />
                </svg>
              </Button>
            </Link>
          </Stack>
        </Stack>{' '}
      </Hidden>
    </RowLayout>
  );
};

export default News;
